<script lang="ts">
	export let value: string
</script>

<h3>BoxesBigTextRatingBox</h3>
{#if value}
	<p>Value: {value}</p>
{/if}
